import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isModalOpen: false,
};

const deleteConfirmModalSlice = createSlice({
  name: "deleteConfirmModal",
  initialState,
  reducers: {
    openDeleteConfirmModal: (state) => {
      state.isModalOpen = true;
    },
    closeDeleteConfirmModal: (state) => {
      state.isModalOpen = false;
    },
  },
});

export const { openDeleteConfirmModal, closeDeleteConfirmModal } = deleteConfirmModalSlice.actions;
export default deleteConfirmModalSlice.reducer;